export enum TemplateEnum {
  MANDAT_GESTION = 'mandat-gestion',
  DECHARGE_NON_CONFORMITE = 'decharge-non-conformite',
  DECHARGE_TVX_SANS_DECLARATION = 'decharge-travaux-sans-declaration',
  BDC = 'bdc',
  UPSELL = 'upsell',
  DECHARGE_CLIENT = 'decharge-client',
}
